import React from 'react';
import Styles from './StoreProposalSent.css';
import ContainerHome24 from '../../../../components/atoms/ContainerHome24';
import Button from '../../widgets/Button/Button';
import { useLayout, useScroll } from '../../../../utils/useLayout';
import { useSimuladorEnergiaSolarState } from '../../model/state';
import { SIMULATION_STEPS } from '../../model/simulation-steps';

function StoreProposalSent() {
  const { mobile } = useLayout();
  const { scrollToTop } = useScroll();
  const { simulationStep, restartSimulation } = useSimuladorEnergiaSolarState();

  const visible = simulationStep?.id === SIMULATION_STEPS.END_JOURNEY_STORE_PROPOSAL_SENT.id;
  if (!visible) return null;

  return (
    <>
      <div id="store-proposal-sent" className="store-proposal-sent">
        <ContainerHome24>
          <div className="content-wrapper">
            <div className="content-img">
              <picture className="img-proposal">
                <source
                  media="(min-width: 992px)"
                  srcSet="assets/simulador-energia-solar/jornada/proposal-sent-desk.svg"
                />
                <img src="assets/simulador-energia-solar/jornada/proposal-sent.svg" alt="" />
              </picture>
            </div>

            <div className="content-text">
              <h6 className="text-title">
                {mobile
                  ? 'Sua proposta foi encaminhada a uma agência Santander'
                  : 'Sua proposta em uma agência Santander'}
              </h6>

              <p className="text-description">
                A loja informada não faz parte da nossa rede de parceiros. Por ser correntista
                Santander, você pode ir até uma agência Santander, onde você pode fazer a simulação
                do seu projeto de energia solar com a loja escolhida.
              </p>
              <div className="next-wrapper-bg">
                <p className="text-next">Próximos passos:</p>
                <ol className="text-next-container">
                  <li className="text-next-item">Vá até uma agência do Santander;</li>
                  <li className="text-next-item">
                    Fale com o gerente da agência e leve seu orçamento;
                  </li>
                  <li className="text-next-item">
                    Faça a proposta na própria agência e conquiste seu financiamento solar.
                  </li>
                </ol>
              </div>
              <Button
                variant="red"
                onClick={(ev) => {
                  ev.preventDefault();
                  scrollToTop();
                  restartSimulation();
                }}
              >
                Ir para a página inicial
              </Button>
            </div>
          </div>
        </ContainerHome24>
      </div>

      <style jsx>{Styles}</style>
    </>
  );
}

export default StoreProposalSent;
